import { UserStore } from './user.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';

@Injectable({ providedIn: 'root' })
export class UserQuery extends BaseQuery {
    constructor(store: UserStore) {
        super(store);
    }
}
